import React, { ReactElement } from 'react';
import WentWellArt from './WentWellArt';
import StartStopContinueArt from './StartStopContinueArt';
import MadSadGladArt from './MadSadGladArt';
import CirclesOfControlArt from './CirclesOfControlArt';

export interface TemplateArtProps {
  templateId: string;
  isDarkMode: boolean;
  /** Smaller rendering for picker thumbnails. */
  compact?: boolean;
}

export default function TemplateArt({ templateId, isDarkMode }: TemplateArtProps): ReactElement | null {
  switch (templateId) {
    case 'went-well':
      return <WentWellArt isDarkMode={isDarkMode} />;
    case 'start-stop-continue':
      return <StartStopContinueArt isDarkMode={isDarkMode} />;
    case 'mad-sad-glad':
      return <MadSadGladArt isDarkMode={isDarkMode} />;
    case 'circles-of-control':
      return <CirclesOfControlArt isDarkMode={isDarkMode} />;
    default:
      return null;
  }
}
